<template>
  <div class="price-result-grid">
    <div
      class="price-result-item"
      v-for="(priceItem, priceIndex) in priceTotalResult"
      :class="tableRowIndex == priceIndex ? 'cur-quote-style' : ''"
      @mouseenter="handleMouseEnter(priceIndex)"
    >
      <p class="price-result-title">第{{ toCn(priceIndex + 1) }}报价总额</p>
      <p class="concrete-price-item">
        <span class="label">零件总价</span>
        <span class="value">{{ priceItem.partTotal }}</span>
      </p>
      <p class="concrete-price-item">
        <span class="label">模具费</span>
        <span class="value">{{ priceItem.mouldTotal }}</span>
      </p>
      <p class="concrete-price-item">
        <span class="label">杂费</span>
        <span class="value">{{ priceItem.otherTotal }}</span>
      </p>
      <p class="concrete-price-item" style="margin-bottom: 16px">
        <span class="label">运费</span>
        <span class="value">{{ priceItem.freightTotal }}</span>
      </p>
      <p class="new-concrete-price-item">
        <span class="label">报价单总额</span>
        <span class="value">{{ priceItem.curQuoteTotal }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations,mapState } from 'vuex'
export default {
  name: 'part-price-info',
  props: {
    priceTotalResult: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      //
    }
  },
  methods: {
    ...mapMutations('zhenyunStore',{
      setTableRowIndex: 'SET_TABLEROWINDEX'
    }),
    handleMouseEnter(index){
      this.setTableRowIndex(index)
    },
    toCn(index) {
      switch (index) {
        case 1:
          return '一'
        case 2:
          return '二'
        case 3:
          return '三'
        default:
          return '一'
      }
    },
  },
  mounted() {
    //
  },
  computed: {
    ...mapState('zhenyunStore', ['tableRowIndex']),
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.price-result-grid {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  // display: grid;
  // grid-template-columns: repeat(3, 1fr);
  // grid-gap: 16px;
  padding: 16px;
  font-family: SourceHanSansCN-Regular;
  .price-result-item {
    width: calc(368px - 28px * 2);
    flex-shrink: 0;
    background: #f5f7fa;
    border: 2px solid #f5f7fa;
    padding: 24px;
    .price-result-title {
      color: #222222;
      font-size: 14px;
      font-family: SourceHanSansCN-bold;
      line-height: 22px;
      padding-bottom: 16px;
    }
    .concrete-price-item {
      display: flex;
      justify-content: space-between;
      color: #555555;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 8px;
      .value {
        color: #222222;
      }
    }
    .new-concrete-price-item {
      display: flex;
      justify-content: space-between;
      color: #555555;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      padding-top: 16px;
      border-top: 1px solid #dcdcdc;
      .value {
        color: #222222;
        font-family: SourceHanSansCN-bold;
      }
    }
  }
  .price-result-item.cur-quote-style{
    border: 2px solid #FF7800;
    background: #FFFAF3;
    .new-concrete-price-item{
      .value{
        color: #FF7800;
      }
      
    }
  }
}
</style>
